export default __webpack_public_path__ + "static/media/philexport-min.23a33bd5.png";